import React from 'react';
import { FontFamilyInput } from '../../../SidebarMenu/styles';
import FontSideBar from '../../FontSideBar';

export const FontFamilySelector = ({ fontFamily, onFontToggle, changeFontFamily, fontListVisible, CurrentDesign }) => {
  return (
    <>
      <FontFamilyInput complexDocumentDesign className='doc-settings-width'>
        <div onClick={onFontToggle} className="input">
          <span style={{ color: 'black' }}>{fontFamily}</span>
        </div>
      </FontFamilyInput>
      {fontListVisible && (
        <FontSideBar
          itemUUID={undefined}
          editor={undefined}
          setFontChange={changeFontFamily}
          fontFamily={fontFamily}
          isToolBarVisible={fontListVisible}
          closeFontList={onFontToggle}
          isAbsolute={true}
          CurrentDesign={CurrentDesign}
        />
      )}
    </>
  );
};


